import { APP_CONFIG } from "@/data/constants";

/** 베타 기간에도 캘린더 예약을 사용 (상담 전용 모드 해제) */
export const LESSON_CONSULTATION_ONLY = false;

export const LESSON_KAKAO_CHANNEL_HANDLE = "@connect-tone";
export const LESSON_KAKAO_CHANNEL_URL = APP_CONFIG.KAKAO_CHANNEL_URL;

export const LESSON_PRICE_DISPLAY_LABEL = "상담문의";

export function isLessonConsultationOnly(): boolean {
  return LESSON_CONSULTATION_ONLY;
}

export function getLessonKakaoInquiryMessage(): string {
  return `베타 기간에는 레슨 신청·결제 대신 카카오톡 채널 ${LESSON_KAKAO_CHANNEL_HANDLE} 로 문의해 주세요.`;
}

export function openLessonKakaoInquiry(): void {
  if (typeof window !== "undefined") {
    window.open(LESSON_KAKAO_CHANNEL_URL, "_blank", "noopener,noreferrer");
  }
}
